function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
/* Update cart items */
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );

      this.debouncedOnChange = debounce((event) => {
        if (event.target != document.getElementById('Cart-note')) {
          this.onChange(event);
        }
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      // catch event, either variant change or quantity change. If variant change, remove the item in the cart and add the new variant with the same quantity
      const type = event.target.dataset.changeType;

      if (type === 'variant') {
        // remove the old item first and when the cart has been updated, add the new variant.
        this.updateQuantity(event.target.dataset.index, 0, 'variantChange', event.target);
      }
      // update quantity
      if (type === 'quantity') {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name')
        );
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!section?.selector) return;

        const selectors = document.querySelectorAll(section.selector);

        if (!selectors) return;

        selectors.forEach((selector) => {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      });

      // Re-bind the close drawer buttons
      this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );
    }

    updateQuantity(line, quantity, name, select) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          // if this is variant change, don't update any sections
          if (name === 'variantChange') {
            // add the new item
            this.updateVariant(select);
            return;
          }

          const parsedState = JSON.parse(state);
          this.closest('.cart-items').classList.toggle(
            'cart-is-empty',
            parsedState.item_count === 0
          );

          this.getSectionsToRender().forEach((section) => {
            const sectionsToReplace = document.querySelectorAll(`#${section.id}`);

            sectionsToReplace.forEach((sectionToReplace) => {
              const selector = sectionToReplace.querySelector(section.selector);

              selector.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
          });

          this.updateLiveRegions(line, parsedState.item_count);
          document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        })
        .catch((error) => {
          document.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
          document.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading();
        });
    }

    updateVariant(select) {
      let quantity = parseInt(select.dataset.currentQuantity);

      // check if current qty is bigger than max inventory of the new variant
      const maxQuantity = parseInt(select.selectedOptions[0].dataset.inventoryQuantity);
      if (quantity > maxQuantity) {
        quantity = maxQuantity;
      }

      // Check if product is a pre order product. Then we should take the quantity of the quantity selector
      const quantityInput = select
        .closest('.cart-drawer-item')
        .querySelector('input[type="number"]');
      const preOrder = select.dataset.preOrder;
      if (preOrder === 'true') {
        quantity = quantityInput.valueAsNumber;
      }

      let body = JSON.stringify({
        items: [
          {
            id: parseInt(select.value),
            quantity,
          },
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((state) => {
          if (state.status == 422) {
            // When quantity error
            return;
          }
          // get the cart now the item has been added
          this.getCart(state);
        })
        .catch((error) => {
          this.errorFunctions(error);
        });
    }

    getCart(state) {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.text())
        .then(() => {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            if (document.querySelector(section.selector)) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                state.sections[section.section],
                section.selector
              );
            }
          });

          // because changed element is a new item in the cart, it's at the top, so scroll to it
          document.getElementById('cart-drawer')?.scrollTo({ top: 0, behavior: 'smooth' });

          this.disableLoading();
        })
        .catch((error) => {
          this.errorFunctions(error);
        });
    }

    errorFunctions(error) {
      console.error('Error updating item:', error);
      const cartErrorsElement = document.getElementById('cart-errors');
      document.querySelector('.loading-overlay').classList.add('hidden');
      cartErrorsElement.classList.remove('hidden');
      cartErrorsElement.textContent = window.cartStrings.error;
      this.disableLoading();
    }

    // show error texts, should not be deleted.
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text').innerHTML =
          window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document.querySelector('cart-items').classList.add('cart-items-is-loading');
      document.querySelector('[data-cart-loader-active="show"]')?.classList.remove('hidden');
      document.querySelector('[data-cart-loader-active="hidden"]')?.classList.add('hidden');
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) cartItems.classList.remove('cart-items-is-loading');
    }
  }
  customElements.define('cart-items', CartItems);
}

/* Remove item from the cart  */
if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      });
    }
  }
  customElements.define('cart-remove-button', CartRemoveButton);
}

/* Update the cart note */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);
}
